import { render } from "./Beyond.vue?vue&type=template&id=6c2350c0&scoped=true"
import script from "./Beyond.vue?vue&type=script&lang=js"
export * from "./Beyond.vue?vue&type=script&lang=js"

import "./Beyond.vue?vue&type=style&index=0&id=6c2350c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2350c0"]])

export default __exports__